import apiHandler from "../core/apiHandler";

const inventoryMovementApi = apiHandler('inventory/movements');
export default inventoryMovementApi;
